export const GRID_COLS = 20;
export const GRID_ROWS = 20;
export const TILE_WIDTH = 64;
export const TILE_HEIGHT = 32;

export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

export const BPM = 128;
export const BEAT_INTERVAL_MS = 60_000 / BPM; // ~468ms

export const SIMULATION_TICK_RATE = 4; // ticks per second
export const SIMULATION_TICK_MS = 1000 / SIMULATION_TICK_RATE;

export const STARTING_BUDGET = 5000;

export const CAMERA_ZOOM_MIN = 0.5;
export const CAMERA_ZOOM_MAX = 2.0;
export const CAMERA_PAN_SPEED = 8;

export enum EquipmentType {
  DJ_BOOTH = 'DJ_BOOTH',
  SPEAKER = 'SPEAKER',
  LASER = 'LASER',
  STROBE = 'STROBE',
  FOG_MACHINE = 'FOG_MACHINE',
  BAR = 'BAR',
  DANCE_FLOOR = 'DANCE_FLOOR',
}

export interface EquipmentDef {
  type: EquipmentType;
  name: string;
  cost: number;
  operatingCost: number; // per tick
  radius: number; // effect radius in tiles
  color: number;
}

export const EQUIPMENT_DEFS: Record<EquipmentType, EquipmentDef> = {
  [EquipmentType.DJ_BOOTH]: {
    type: EquipmentType.DJ_BOOTH,
    name: 'DJ Booth',
    cost: 800,
    operatingCost: 2,
    radius: 0,
    color: 0xff00ff,
  },
  [EquipmentType.SPEAKER]: {
    type: EquipmentType.SPEAKER,
    name: 'Speaker',
    cost: 300,
    operatingCost: 1,
    radius: 6,
    color: 0x666666,
  },
  [EquipmentType.LASER]: {
    type: EquipmentType.LASER,
    name: 'Laser',
    cost: 400,
    operatingCost: 1,
    radius: 8,
    color: 0x00ff00,
  },
  [EquipmentType.STROBE]: {
    type: EquipmentType.STROBE,
    name: 'Strobe',
    cost: 200,
    operatingCost: 1,
    radius: 5,
    color: 0xffffff,
  },
  [EquipmentType.FOG_MACHINE]: {
    type: EquipmentType.FOG_MACHINE,
    name: 'Fog Machine',
    cost: 250,
    operatingCost: 1,
    radius: 4,
    color: 0xcccccc,
  },
  [EquipmentType.BAR]: {
    type: EquipmentType.BAR,
    name: 'Bar',
    cost: 500,
    operatingCost: 0,
    radius: 0,
    color: 0xff6600,
  },
  [EquipmentType.DANCE_FLOOR]: {
    type: EquipmentType.DANCE_FLOOR,
    name: 'Dance Floor',
    cost: 50,
    operatingCost: 0,
    radius: 0,
    color: 0x9900ff,
  },
};

export const DRINK_PRICE = 10;
export const TICKET_PRICE = 15;
export const DEMOLISH_REFUND_RATE = 0.5;
